export default "__VITE_ASSET__BYhX5xRt__"